import { NgModule } from '@angular/core';

import { PropertyDivisionModule } from '../property-division.module';
import { PropertyDivisionFormPjComponent } from './property-division-form-pj/property-division-form-pj.component';
import { PropertyDivisionStagePjComponent } from './property-division-stage-pj/property-division-stage-pj.component';
import { PropertyDivisionSuccessPjComponent } from './property-division-success-pj/property-division-success-pj.component';
import { SharedComponentsModule } from '../components/shared-components/shared-components.module';

@NgModule({
  declarations: [
    PropertyDivisionFormPjComponent,
    PropertyDivisionStagePjComponent,
    PropertyDivisionSuccessPjComponent,
  ],
  imports: [
    PropertyDivisionModule,
    SharedComponentsModule,
  ],

  exports: [
    PropertyDivisionFormPjComponent,
    PropertyDivisionStagePjComponent,
    PropertyDivisionSuccessPjComponent,
  ],
})
export class PropertyDivisionPjModule {}
